/**
 * Sélecteur de langue/pays — soumission automatique au changement.
 *
 * Sans JavaScript, le bouton « Appliquer » reste visible et soumet le
 * formulaire ; avec JS, il est masqué et la sélection s'applique aussitôt.
 */
class LocalizationForm extends HTMLElement {
  connectedCallback() {
    const form = this.querySelector('form');
    if (!form) return;

    this.querySelector('.localization__submit')?.setAttribute('hidden', '');

    this.querySelectorAll('select').forEach((select) => {
      select.addEventListener('change', () => form.submit());
    });
  }
}

if (!customElements.get('localization-form')) {
  customElements.define('localization-form', LocalizationForm);
}
